import { createAction, props } from "@ngrx/store";
import {Index } from "../interfaces/State/Fixture/index";

export const setUpcomingFixtures = createAction('setUpcomingFixtures', props<{fixtures: Array<Index>}>())
export const setOpenedFixture = createAction('setOpenedFixture', props<{fixture: Index}>())